import { getAnchorId, getComponentMargin } from '@/utils/builderUtils';
import FaqParagraph from '@/components/Faqs/FaqParagraph';

export default function FaqParagraphBuilder({ title, description, anchorLinkID, margin }) {
  return (
    <div {...getAnchorId(anchorLinkID)}>
      <FaqParagraph title={title} description={description} className={getComponentMargin(margin)} />
    </div>
  );
}
